import { render, staticRenderFns } from "./order_pay.vue?vue&type=template&id=c19e6a2c&scoped=true"
import script from "./order_pay.vue?vue&type=script&lang=js"
export * from "./order_pay.vue?vue&type=script&lang=js"
import style0 from "./order_pay.vue?vue&type=style&index=0&id=c19e6a2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19e6a2c",
  null
  
)

export default component.exports